import { gql } from '@apollo/client';

export const fetchInvoiceGroupsForTransactionAccount = gql`
  query fetchInvoiceGroupsForTransactionAccount($id: ID!) {
    transactionAccount(id: $id) {
      id
      availableInvoiceGroups {
        totalCount
        nodes {
          id
          name
          currency
          purchaseOrder {
            number
            oneTimeUse
          }
          shipToParty {
            name
            id
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
            taxIds {
              id
              label
            }
          }
          defaultPaymentMethod {
            id
            type
            paymentIssue
            default
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
        }
      }
    }
  }
`;
